export const MOBILE_FUNNEL_ENTRY = '/selfie' as const;
